import { notifications } from "@mantine/notifications";
import { AxiosError } from "axios";

export const showAPIError = (error: any) => {
	if (error?.response?.status == 400) {
		let axiosError: AxiosError = error as AxiosError;
		if (axiosError.response) {
			notifications.show({
				title: "Error",
				message: `${(axiosError.response.data as any).Title ?? axiosError.response.data}`,
				color: "red",
				autoClose: 10000
			});
			return;
		} else {
			notifications.show({
				title: "Error",
				message: `An error occurred performing this request.`,
				color: "red",
				autoClose: 5000
			});
		}
	}
}